import LandingPage from './Page/LandingPage/LandingPage';
import AccessPage from './Page/AccessPage/AccessPage';
import  LoginPage  from './Page/LoginPage/LoginPage';
import ManagementSystem from './Page/ManagementSystem/ManagementSystem';
import { BrowserRouter as Router, Route, Routes,useNavigate  } from 'react-router-dom';
import SignUpPage from './Page/SignUpPage/SignUpPage';

import ForgetPassword from './Page/ForgetPasswordPage/ForgetPassword';
import DealerSignupPage from './Page/SignUpPage/DealerSignupPage';
import DealerManagementSystem from './Page/ManagementSystem/DealerManagementSystem';
import MainHeader from './Components/MainHeader/MainHeader';
import NewLoginPage2 from './Page/DealerEmployeeLandingPage/NewLoginPage2';
import DealerMSPIN from './Page/DealerEmployeeLandingPage/DealerMSPIN';
import SumaryReportPage from './Page/DownloadPage/SummaryReportPage';
import Userlog from "./Page/UserLogs/userLogs"

import ErrorPage from './Page/ErrorPage/ErrorPage';
// import ForgetPassword from './Page/ForgetPasswordPage/ForgetPassword';
export default function Routing(){
    const navigate = useNavigate();

  return (
    <div className="App">

   
      <Routes >

        <Route exact path="/gis" element={<AccessPage nav={navigate}/>}/>
        {/* <Route  path="/" element={<LoginPage nav={navigate}/>}/> */}
        {/* <Route  path="/login" element={<LoginPage nav={navigate}/>}/> */}
        {/* <Route exact path="/" element={<LandingLoginPage nav={navigate}/>}/> */}
        <Route exact path="/" element={<NewLoginPage2 nav={navigate}/>}/>
        <Route exact path="/logout" element={<NewLoginPage2 nav={navigate}/>}/>
        <Route exact path="/signup" element={<SignUpPage nav={navigate}/>}/>
        <Route exact path="/access" element={<LandingPage nav={navigate}/>}/>
        <Route path="/admin" element={<ManagementSystem nav={navigate}/>}/>
        <Route path="/forgetpassword" element={<ForgetPassword nav={navigate}/>}/>
        <Route path="/dealersignup" element={<DealerSignupPage nav={navigate}/>}/>
        <Route path="/dealeradmin" element={<DealerManagementSystem nav={navigate}/>}/>
        <Route path="/mainheader" element={<MainHeader nav={navigate}/>}/>
        <Route path="/dealerlogin" element={<DealerMSPIN nav={navigate}/>}/>
        <Route path="/error" element={<ErrorPage nav={navigate} />} />
        <Route path="/userlog" element={<Userlog nav={navigate} />} />
        <Route path="/summary" element={<SumaryReportPage nav={navigate} />} />
        <Route
          path="/*"
          element={
            <ErrorPage
              nav={navigate}
              message="The page you are trying to access is temporarily unavailable."
            />
          }
        />
        {/* <Route path="/*" element={<ErrorPage nav={navigate} message='The page you are trying to access is temporarily unavailable.'/>}/> */}
        
      </Routes >
    </div>
  );
}